// extracted by mini-css-extract-plugin
export default {"clickableRow":"ClientsTableRow_clickableRow__jHOEg","disabled":"ClientsTableRow_disabled__XpxRU","ellipsis":"ClientsTableRow_ellipsis__-vN-z"};